import React, { useState } from 'react';
import InfoIconButton from '../../InfoIconButton';
import { ageInMonthsDisplay } from '../../../utils/ageInMonths';

function BasicInfoSection({ formData, handleChange, staff, canAssignStaff = true }) {
  const [lastContactedHintOpen, setLastContactedHintOpen] = useState(false);
  const ageDisplay = ageInMonthsDisplay(formData.date_of_birth);
  const assignedStaffMember = (staff || []).find((s) => String(s.id) === String(formData.assigned_staff_id));
  const assignedStaffDisplay = assignedStaffMember
    ? `${assignedStaffMember.last_name}, ${assignedStaffMember.first_name}`
    : (formData.assigned_staff_id ? '—' : 'Unassigned');
  return (
    <div className="form-section">
      <h3 className="section-title">Basic Information</h3>
      <div className="basic-info-grid">
        <div className="basic-info-row basic-info-row-names">
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name || ''}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Middle Name</label>
            <input
              type="text"
              name="middle_name"
              value={formData.middle_name || ''}
              onChange={handleChange}
              placeholder="Optional; initial or full name"
            />
          </div>

          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name || ''}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="basic-info-row basic-info-row-dob-sc">
          <div className="form-group">
            <div className="form-group-dob-label-row">
              <label>Date of Birth *</label>
              {ageDisplay != null && (
                <span className="form-group-dob-age" aria-live="polite">
                  Age: {ageDisplay}
                </span>
              )}
            </div>
            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth || ''}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Gestation (weeks)</label>
            <select
              name="gestation_week"
              value={formData.gestation_week ?? ''}
              onChange={handleChange}
            >
              <option value="">—</option>
              {Array.from({ length: 21 }, (_, i) => 40 - i).map((w) => (
                <option key={w} value={w}>
                  {w}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            {canAssignStaff ? (
              <>
                <label htmlFor="basic-info-assigned-staff">Assigned SC</label>
                <select
                  id="basic-info-assigned-staff"
                  name="assigned_staff_id"
                  value={formData.assigned_staff_id || ''}
                  onChange={handleChange}
                  title="Assigned service coordinator"
                >
                  <option value="">Unassigned</option>
                  {(staff || []).map((member) => (
                    <option key={member.id} value={member.id}>
                      {member.last_name}, {member.first_name}
                    </option>
                  ))}
                </select>
              </>
            ) : (
              <>
                <label>Assigned SC</label>
                <div className="readonly-field" aria-live="polite">{assignedStaffDisplay}</div>
              </>
            )}
          </div>
        </div>

        <div className="basic-info-row basic-info-row-ids-contact">
          <div className="form-group">
            <label>EI Number</label>
            <input
              type="text"
              name="ei_number"
              value={formData.ei_number || ''}
              onChange={handleChange}
              maxLength={30}
            />
          </div>

          <div className="form-group">
            <label>Participant ID</label>
            <input
              type="text"
              name="participant_id"
              value={formData.participant_id || ''}
              onChange={handleChange}
              maxLength={30}
            />
          </div>

          <div className="form-group">
            <label className="label-with-info" htmlFor="basic-info-last-contacted">
              Last contacted
              <InfoIconButton
                ariaExpanded={lastContactedHintOpen}
                ariaControls="last-contacted-hint"
                ariaLabel="Show explanation"
                ariaLabelExpanded="Hide explanation"
                onClick={() => setLastContactedHintOpen((v) => !v)}
              />
            </label>
            {lastContactedHintOpen && (
              <p id="last-contacted-hint" className="form-group-hint form-group-hint-below-label">
                Used for monthly contact compliance (must contact every calendar month)
              </p>
            )}
            <input
              id="basic-info-last-contacted"
              type="date"
              name="last_contacted_at"
              value={formData.last_contacted_at || ''}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="basic-info-last-contact-method">Contact method</label>
            <select
              id="basic-info-last-contact-method"
              name="last_contact_method"
              value={formData.last_contact_method || ''}
              onChange={handleChange}
            >
              <option value="">—</option>
              <option value="meeting">Meeting</option>
              <option value="phone">Phone</option>
              <option value="email_personal">Email (personal)</option>
              <option value="email_system">Email (system)</option>
              <option value="text">Text</option>
              <option value="letter">Letter</option>
            </select>
          </div>
        </div>
      </div>

      <div className="basic-info-sc-note-block">
        <label htmlFor="basic-info-sc-note">SC Note</label>
        <textarea
          id="basic-info-sc-note"
          name="sc_note"
          className="basic-info-sc-note-textarea"
          rows={2}
          value={formData.sc_note || ''}
          onChange={handleChange}
          placeholder="Optional"
        />
      </div>
    </div>
  );
}

export default BasicInfoSection;
